module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko_samples/main_sp_8c3431c3c38069a913e02e46abc4ed17.jpg";